import { Button } from "semantic-ui-react";
import { createPortal } from "react-dom";
import phoneFilled from "../../../../pages/Viewer/Images/newPhone_outline.svg";
import { useState, useRef, useEffect } from "react";
import { useWhiteboardingStore } from "../../../../store";

const MENU_GAP = 4;
const PORTAL_Z_INDEX = 10002;
const MENU_WIDTH = 260;

const ConferenceSelection = (props: any) => {
    const { role, setShowPopup, showPopup, handelVideoConfEnd, refreshRoomCode, handelVideoConfEndAll } = props;
    const [, setEndorLeaveConferenceLoading] = useState(false);
    const [menuPosition, setMenuPosition] = useState<{ top: number; left: number } | null>(null);
    const triggerRef = useRef<HTMLDivElement>(null);
    const { resetAllTools } = useWhiteboardingStore();

    const toggleTools = () => {
        setShowPopup(!showPopup);
        resetAllTools();
    };

    useEffect(() => {
        if (showPopup && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setMenuPosition({ top: rect.bottom + MENU_GAP, left: rect.left });
        } else {
            setMenuPosition(null);
        }
    }, [showPopup]);

    useEffect(() => {
        if (!showPopup) return;
        const onDocClick = (e: MouseEvent) => {
            if (triggerRef.current?.contains(e.target as Node)) return;
            if (document.querySelector(".cameraMenu-portal-wrapper")?.contains(e.target as Node)) return;
            setShowPopup(false);
        };
        document.addEventListener("click", onDocClick, true);
        return () => document.removeEventListener("click", onDocClick, true);
    }, [showPopup, setShowPopup]);

    const endConferenceForAll = async () => {
        try {
            setEndorLeaveConferenceLoading(true);
            await handelVideoConfEndAll(false);
            setEndorLeaveConferenceLoading(false);
        } catch (err) {
            console.error(err);
            setEndorLeaveConferenceLoading(false);
        }
    };

    const closeMenu = () => setShowPopup(false);

    const menuContent = (
        <div
            className="menu transition visible cameraMenu cameraMenu-portal"
            role="listbox"
            onClick={(e) => e.stopPropagation()}
        >
            {role !== "host" ? (
                <div className="item">
                    <Button
                        className="ui button viewer-menu-btn"
                        onClick={() => { handelVideoConfEnd(); closeMenu(); }}
                        style={{ backgroundColor: "white", width: "183px" }}
                    >
                        Leave Conference
                    </Button>
                </div>
            ) : (
                <>
                    <div className="item">
                        <Button className="ui button viewer-menu-btn" onClick={() => { refreshRoomCode(); closeMenu(); }}>
                            End Conference and Refresh Codes
                        </Button>
                    </div>
                    <div className="item">
                        <Button className="ui button viewer-menu-btn" onClick={() => { endConferenceForAll(); closeMenu(); }}>
                            End Conference for All
                        </Button>
                    </div>
                    <div className="item">
                        <Button className="ui button viewer-menu-btn" onClick={() => { handelVideoConfEnd(); closeMenu(); }}>
                            Leave Conference
                        </Button>
                    </div>
                </>
            )}
        </div>
    );

    const portaledMenu = showPopup && menuPosition && createPortal(
        <div
            className="cameraMenu-portal-wrapper"
            style={{ position: "fixed", top: menuPosition.top, left: menuPosition.left, zIndex: PORTAL_Z_INDEX, width: MENU_WIDTH }}
        >
            {menuContent}
        </div>,
        document.body
    );

    return (
        <>
            <div
                ref={triggerRef}
                className="top-menu-button-item call-options-dropdown"
                onClick={toggleTools}
            >
                <img src={phoneFilled} alt="" />
                <span>Action</span>
            </div>
            {portaledMenu}
        </>
    );
};

export default ConferenceSelection;
